// Home.jsx
import React from 'react';
import Hero from '../components/Hero';
import WhyChooseMe from '../components/WhyChooseMe';
import ServicesMarquee from '../components/ServicesMarquee';
import ProcessRoadmap from '../components/ProcessRoadmap';
import TestimonialsSlider from '../components/TestimonialsSlider';
import ScrollToTopButton from '../components/ScrollToTopButton';

const Home = () => {
  return (
    <main className="relative">
      {/* Unified gradient background that spans the entire page */}
      <div className="absolute inset-0 bg-gradient-to-br from-white via-blue-50/30 via-purple-50/20 via-white to-gray-50/50 dark:from-gray-900 dark:via-gray-800/30 dark:via-purple-900/10 dark:via-gray-900 dark:to-gray-800/50"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-blue-50/10 via-transparent to-transparent"></div>
      
      {/* Content sections with relative positioning */}
      <div className="relative">
        {/* Hero Section - Single instance with proper alignment */}
        <section className="min-h-screen flex items-center justify-center px-4">
          <Hero />
        </section>
        
        {/* Why Choose Me Section */}
        <WhyChooseMe />
        
        {/* Services Marquee Section */}
        <ServicesMarquee />
        
        {/* Process Roadmap Section */}
        <ProcessRoadmap />
        
        {/* Testimonials Section */}
        <TestimonialsSlider />
        <ScrollToTopButton />
      </div>
    </main>
  );
};

export default Home;